export default {
  FETCH_DATA: 'billcont_completed_fetch_data',
  UPDATE_QUERY: 'billcont_completed_update_query',
  LOAD_MORE_DATA: 'billcont_completed_load_more_data',
  UPDATE_LOADING: 'billcont_completed_update_loading',
  UPDATE_SELECTED: 'billcont_completed_update_selected',
};
